export const preliveSportsRequest = (dateFactory) => {
    return {
        eventState: "PreLive",
        dateRange: {
            from: new dateFactory().toISOString(),
            timeRange: "SixHours"
        }
    };
};
export const liveSportsRequest = { eventState: "Live" };
export const todaySportsRequest = (from) => {
    return {
        eventState: "Mixed",
        dateRange: {
            from,
            timeRange: "OneDay",
        }
    };
};
export const upcomingLSEventsCountByTagRequest = (from) => preliveLSEventsCountByTagRequest(from, "SixHours");
export const todayLSEventsCountByTagRequest = (from) => preliveLSEventsCountByTagRequest(from, "OneDay");
const preliveLSEventsCountByTagRequest = (from, range) => {
    return {
        eventTags: ["LiveStreaming"],
        eventState: "PreLive",
        eventTypes: ["Fixture"],
        dateRange: {
            from,
            timeRange: range
        }
    };
};
export const liveLSEventsCountByTagRequest = {
    eventTags: ["LiveStreaming"],
    eventTypes: ["Fixture"],
    eventState: "Live"
};
//# sourceMappingURL=SportRequests.js.map